var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loader',{attrs:{"isLoading":_vm.loaderStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }